async function asyncForEach(array: any[], callback: any) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

async function asyncReturnEach(array: any[], callback: any) {
  const results: any[] = []
  for (let index = 0; index < array.length; index++) {
    const newResult = await callback(array[index], index, array)
    return [...results, newResult]
  }
  return results
}

const promiseAllHelper = async <PromiseType>(
  promises: Promise<PromiseType>[]
) => await Promise.all(promises)

export { asyncForEach, asyncReturnEach, promiseAllHelper }
